import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { InputSelect2 } from '../common/Inputs';
import { Translate as t } from '../../config/Translate';

// IMP-475 P4: 장비 목록·재고 목록 공용 소유 회사(운영자) 이관 창. 사유는 선택 입력(최대 500자).
const REASON_MAX_LENGTH = 500;

const ProductTransferModal = ({ show, companies, onTransfer, onClose }) => {
	const [companyId, setCompanyId] = useState('');
	const [reason, setReason] = useState('');

	// 열 때마다 이전 선택·사유를 비운다.
	useEffect(() => {
		if (show) {
			setCompanyId('');
			setReason('');
		}
	}, [show]);

	const doTransfer = () => {
		if (!companyId) return;
		if (typeof onTransfer === 'function') onTransfer(companyId, reason);
		if (typeof onClose === 'function') onClose(false);
	};

	return (
		<Modal show={show} onHide={() => onClose?.(false)} centered>
			<Modal.Header>
				<h2 className="modal-title">{t('user.button.operatorTransfer')}</h2>
			</Modal.Header>
			<Modal.Body className="p-0">
				<ul className="listview simple-listview no-space border-0 m-2">
					<div className="form-group basic">
						<div className="input-wrapper">
							<InputSelect2
								options={{
									name: 'companyId',
									label: t('user.button.transferOperator'),
									val: companyId,
									list: Array.isArray(companies) ? companies : [],
								}}
								editable={true}
								onchange={(e) => setCompanyId(e?.target?.value ?? '')}
							/>
						</div>
					</div>
					<div className="form-group basic">
						<div className="input-wrapper">
							<label className="label">{t('common.field.reason')}</label>
							<textarea className="form-control"
								rows={3}
								maxLength={REASON_MAX_LENGTH}
								placeholder={t('common.placeholder.enterReasonOptional')}
								value={reason}
								onChange={(e) => setReason(e.target.value)}></textarea>
						</div>
					</div>
				</ul>
			</Modal.Body>
			<Modal.Footer>
				<button className="btn btn-block btn-success mb-0" disabled={!companyId} onClick={doTransfer}>{t('common.button.transfer')}</button>
				<button className="btn btn-block btn-dark" onClick={() => onClose?.(false)}>{t('common.button.cancel')}</button>
			</Modal.Footer>
		</Modal>
	);
};

export default ProductTransferModal;
